module.exports = __webpack_public_path__ + "static/media/symptomsicon_ear_pain_uni.100deec8.svg";